import httpClient from "Api/httpClient";

const END_POINT = "/purchase_orders";

const getPurchaseOrders = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getPurchaseOrder = (purchase_order_id) => {
    if (!purchase_order_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + purchase_order_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printPurchaseOrder = (purchase_order_id, view_as = null) => {
    if (!purchase_order_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?purchase_order_id=" + purchase_order_id + "&view_as=" + view_as;
    return httpClient.get(SINGLE_END_POINT);
};

const createPurchaseOrders = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updatePurchaseOrders = (payload, purchase_order_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + purchase_order_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deletePurchaseOrders = (purchase_order_id) => {
    const DELETE_END_POINT = END_POINT + "/" + purchase_order_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const createOrderFromPurchaseOrder = (payload, purchase_order_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CONVERT_END_POINT = "/orders/create_from_purchase_order/" + purchase_order_id;
    return httpClient.post(CONVERT_END_POINT, body);
};

const createBillFromPurchaseOrder = (payload, purchase_order_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CONVERT_END_POINT = "/bills/create_from_purchase_order/" + purchase_order_id;
    return httpClient.post(CONVERT_END_POINT, body);
};

export {
    getPurchaseOrders,
    getPurchaseOrder,
    printPurchaseOrder,
    createPurchaseOrders,
    updatePurchaseOrders,
    deletePurchaseOrders,
    createOrderFromPurchaseOrder,
    createBillFromPurchaseOrder,
};
